var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Vue, Component, Prop } from "vue-facing-decorator";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
var LimitLayoutEnum;
(function (LimitLayoutEnum) {
    LimitLayoutEnum[LimitLayoutEnum["Unknown"] = -1] = "Unknown";
    LimitLayoutEnum[LimitLayoutEnum["All"] = 0] = "All";
    LimitLayoutEnum[LimitLayoutEnum["LowerWarningOnly"] = 1] = "LowerWarningOnly";
    LimitLayoutEnum[LimitLayoutEnum["LowerCriticalOnly"] = 2] = "LowerCriticalOnly";
    LimitLayoutEnum[LimitLayoutEnum["UpperWarningOnly"] = 3] = "UpperWarningOnly";
    LimitLayoutEnum[LimitLayoutEnum["UpperCriticalOnly"] = 4] = "UpperCriticalOnly";
    LimitLayoutEnum[LimitLayoutEnum["LowerWarningCritical"] = 5] = "LowerWarningCritical";
    LimitLayoutEnum[LimitLayoutEnum["UpperWarningCritical"] = 6] = "UpperWarningCritical";
    LimitLayoutEnum[LimitLayoutEnum["UpperLowerCritical"] = 7] = "UpperLowerCritical";
    LimitLayoutEnum[LimitLayoutEnum["LowHighCritical"] = 8] = "LowHighCritical";
    LimitLayoutEnum[LimitLayoutEnum["LowCritical"] = 9] = "LowCritical";
})(LimitLayoutEnum || (LimitLayoutEnum = {}));
let LimitTooltipVue = class LimitTooltipVue extends Vue {
    constructor() {
        super(...arguments);
        this.limit = null;
        this.layoutType = LimitLayoutEnum.Unknown;
        this.limitLayoutEnum = LimitLayoutEnum;
    }
    created() {
        var _a, _b;
        this.limit = ((_a = this.measurement) === null || _a === void 0 ? void 0 : _a.limit) || null;
        if (this.limit == null)
            return;
        let layout = (_b = this.limit) === null || _b === void 0 ? void 0 : _b.layout;
        if (!layout)
            return;
        if (layout.showLowWarning && layout.showLowCritical && layout.showHighWarning && layout.showHighCritical) {
            this.layoutType = LimitLayoutEnum.All;
            return;
        }
        if (layout.showLowWarning && layout.showLowCritical) {
            this.layoutType = LimitLayoutEnum.LowerWarningCritical;
            return;
        }
        if (layout.showHighWarning && layout.showHighCritical) {
            this.layoutType = LimitLayoutEnum.UpperWarningCritical;
            return;
        }
        if (layout.showHighCritical && layout.showLowCritical) {
            this.layoutType = LimitLayoutEnum.UpperLowerCritical;
            return;
        }
        if (layout.showHighCritical) {
            this.layoutType = LimitLayoutEnum.UpperCriticalOnly;
            return;
        }
        if (layout.showHighWarning) {
            this.layoutType = LimitLayoutEnum.UpperWarningOnly;
            return;
        }
        if (layout.showLowCritical) {
            this.layoutType = LimitLayoutEnum.LowerCriticalOnly;
            return;
        }
        if (layout.showLowWarning) {
            this.layoutType = LimitLayoutEnum.LowerWarningOnly;
            return;
        }
    }
    ;
    getValue(value) {
        if (!value && value !== 0)
            return "";
        let result = this.voltageLimit ? MeasurementHelper.formatVoltage(value) :
            this.milliVoltLimit ? MeasurementHelper.getRoundedValueString(value * 1000, 0) :
                MeasurementHelper.getRoundedValueString(value);
        if (!this.milliVoltLimit && result.indexOf(".") == -1)
            return `${result}.0`;
        return result;
    }
    ;
    get canShow() {
        return this.target
            && this.layoutType != LimitLayoutEnum.Unknown ? true : false;
    }
    ;
    get measurementName() {
        var _a, _b;
        (_a = this.limit) === null || _a === void 0 ? void 0 : _a.lowerCriticalLimit;
        return `${(_b = this.measurement) === null || _b === void 0 ? void 0 : _b.measurementTypeName}`;
    }
    ;
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], LimitTooltipVue.prototype, "target", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], LimitTooltipVue.prototype, "measurement", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], LimitTooltipVue.prototype, "voltageLimit", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Object)
], LimitTooltipVue.prototype, "milliVoltLimit", void 0);
LimitTooltipVue = __decorate([
    Component({
        name: "LimitTooltipVue"
    })
], LimitTooltipVue);
export default LimitTooltipVue;
